var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-drawer",
    {
      staticClass: "goods-drawer",
      attrs: {
        size: "50%",
        direction: "rtl",
        visible: _vm.visible,
        withHeader: false,
        "show-close": false,
        wrapperClosable: false
      }
    },
    [
      _c(
        "div",
        { staticClass: "flex flex-column h100-full" },
        [
          _c("div", { staticClass: "f15 pad20 gray3 fb" }, [_vm._v("请选择")]),
          _c(
            "el-form",
            {
              ref: "searchForm",
              staticClass: "pad20-lr",
              attrs: { "label-suffix": "：", inline: true, model: _vm.form }
            },
            [
              _c(
                "el-form-item",
                { attrs: { prop: "name", label: "商品名称" } },
                [
                  _c("el-input", {
                    attrs: { clearable: "", placeholder: "请输入内容" },
                    model: {
                      value: _vm.form.name,
                      callback: function($$v) {
                        _vm.$set(_vm.form, "name", $$v)
                      },
                      expression: "form.name"
                    }
                  })
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { prop: "category_id" } },
                [
                  _c("el-cascader", {
                    attrs: {
                      placeholder: "请选择商品分类",
                      options: _vm.categoryList,
                      props: _vm.categoryProps
                    },
                    on: { change: _vm.categoryChange },
                    model: {
                      value: _vm.categoryIdList,
                      callback: function($$v) {
                        _vm.categoryIdList = $$v
                      },
                      expression: "categoryIdList"
                    }
                  })
                ],
                1
              ),
              _c(
                "el-form-item",
                [
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary", icon: "el-icon-search" },
                      on: { click: _vm.submitSearchForm }
                    },
                    [_vm._v("查询")]
                  ),
                  _c(
                    "el-button",
                    {
                      attrs: { icon: "el-icon-refresh" },
                      on: { click: _vm.resetSearchForm }
                    },
                    [_vm._v("重置")]
                  )
                ],
                1
              )
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "h0 pad20-lr flex-auto over_auto" },
            [
              _c(
                "el-table",
                {
                  directives: [
                    {
                      name: "loading",
                      rawName: "v-loading",
                      value: _vm.loading,
                      expression: "loading"
                    }
                  ],
                  ref: "multipleTable",
                  attrs: {
                    "row-key": "id",
                    data: _vm.list,
                    "tree-props": { children: "skuList2" }
                  },
                  on: {
                    select: _vm.select,
                    "select-all": _vm.selectAll,
                    "selection-change": _vm.selectionChange
                  }
                },
                [
                  _c("el-table-column", {
                    attrs: {
                      "class-name": _vm.disableSKUSelection
                        ? "disable-selection"
                        : "",
                      type: "selection",
                      width: "55",
                      "reserve-selection": "",
                      selectable: _vm.selectionDisable
                    }
                  }),
                  _c("el-table-column", {
                    attrs: {
                      prop: "name",
                      "show-overflow-tooltip": "",
                      label: "商品名称"
                    }
                  }),
                  _c("el-table-column", {
                    attrs: { prop: "images", label: "商品图", width: "200" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function(scope) {
                          return [
                            scope.row.picUrl
                              ? _c("img", {
                                  staticClass: "absolute img pointer",
                                  attrs: {
                                    src:
                                      scope.row.picUrl +
                                      "?imageView2/1/w/80/h/40"
                                  },
                                  on: {
                                    click: function($event) {
                                      return _vm.imgPreview(scope.row.picUrl)
                                    }
                                  }
                                })
                              : _c("span", [_vm._v("-")])
                          ]
                        }
                      }
                    ])
                  }),
                  _c("el-table-column", {
                    attrs: {
                      prop: "unitName",
                      label: "计量单位",
                      width: "150"
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function(scope) {
                          return [
                            scope.row.unitName
                              ? _c("span", [_vm._v(_vm._s(scope.row.unitName))])
                              : _c("span", [_vm._v("-")])
                          ]
                        }
                      }
                    ])
                  })
                ],
                1
              )
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "flex gray9 items-center pad20-lr pad15-t" },
            [
              _c("div", { staticClass: "flex-auto" }, [
                _vm._v(
                  "共 " +
                    _vm._s(_vm.total) +
                    " 条记录 第 " +
                    _vm._s(_vm.pageNum) +
                    " / " +
                    _vm._s(_vm.pageCount) +
                    " 页"
                )
              ]),
              _c("el-pagination", {
                attrs: {
                  background: "",
                  layout: "prev, pager, next, sizes, jumper",
                  "hide-on-single-page": "",
                  "page-size": _vm.pageSize,
                  "page-count": _vm.pageCount,
                  "current-page": _vm.pageNum,
                  "page-sizes": [30, 50, 100]
                },
                on: {
                  "update:pageSize": function($event) {
                    _vm.pageSize = $event
                  },
                  "update:page-size": function($event) {
                    _vm.pageSize = $event
                  },
                  "update:currentPage": function($event) {
                    _vm.pageNum = $event
                  },
                  "update:current-page": function($event) {
                    _vm.pageNum = $event
                  },
                  "size-change": _vm.sizeChange,
                  "current-change": _vm.currentChange
                }
              })
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "pad20 gray9 flex items-center" },
            [
              _c("div", { staticClass: "flex-auto" }, [
                _vm._v(
                  "已选择 " + _vm._s(_vm.multipleSelectionLength) + " 个商品"
                )
              ]),
              _c(
                "el-button",
                { staticClass: "mar15-l", on: { click: _vm.cancel } },
                [_vm._v("取 消")]
              ),
              _c(
                "el-button",
                {
                  staticClass: "mar15-l",
                  attrs: { type: "primary" },
                  on: { click: _vm.confirm }
                },
                [_vm._v("确 定")]
              )
            ],
            1
          )
        ],
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }